import { render, staticRenderFns } from "./newGift.vue?vue&type=template&id=d58bb370&scoped=true"
import script from "./newGift.vue?vue&type=script&lang=js"
export * from "./newGift.vue?vue&type=script&lang=js"
import style0 from "./newGift.vue?vue&type=style&index=0&id=d58bb370&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58bb370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d58bb370')) {
      api.createRecord('d58bb370', component.options)
    } else {
      api.reload('d58bb370', component.options)
    }
    module.hot.accept("./newGift.vue?vue&type=template&id=d58bb370&scoped=true", function () {
      api.rerender('d58bb370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/platformCoupon/couponList/newGift.vue"
export default component.exports